import { apiClient } from './client';
import type { ApiSuccess, PaginationMeta } from '../types';

export type ClosureStatus = 'draft' | 'submitted' | 'closed' | 'rejected';

export interface ClosureReconciliation {
  boqApproved: number; poOrdered: number; workOrders: number; invoiced: number; collected: number;
  vendorApproved: number; vendorPaid: number; retentionHeld: number; outstanding: number; overallProgressPct: number;
}
export interface EpcClosure {
  id: number; closureCode: string; projectId: number; status: ClosureStatus;
  retentionReleaseAmount: number; closureDate: string | null; remarks: string | null;
  submittedAt: string | null; approvedAt: string | null; createdAt: string;
  reconciliation?: ClosureReconciliation;
}

interface Paginated<T> { data: T[]; meta: PaginationMeta }

export const epcClosureApi = {
  async list(params: Record<string, unknown> = {}): Promise<Paginated<EpcClosure>> {
    const { data } = await apiClient.get<ApiSuccess<EpcClosure[]>>('/epc-closures', { params });
    return { data: data.data, meta: data.meta as PaginationMeta };
  },
  get: async (id: number) => (await apiClient.get<ApiSuccess<EpcClosure>>(`/epc-closures/${id}`)).data.data,
  create: async (body: { projectId: number; retentionReleaseAmount?: number; remarks?: string }) =>
    (await apiClient.post<ApiSuccess<EpcClosure>>('/epc-closures', body)).data.data,
  remove: async (id: number) => (await apiClient.delete(`/epc-closures/${id}`)).data,
  submit: async (id: number) => (await apiClient.post<ApiSuccess<EpcClosure>>(`/epc-closures/${id}/submit`, {})).data.data,
  approve: async (id: number, remarks?: string) => (await apiClient.post<ApiSuccess<EpcClosure>>(`/epc-closures/${id}/approve`, { remarks })).data.data,
  reject: async (id: number, reason: string) => (await apiClient.post<ApiSuccess<EpcClosure>>(`/epc-closures/${id}/reject`, { reason })).data.data,
};
